import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import userReducer from './slices/userSlice';
import entityReducer from './slices/entitySlice';
import systemReducer from './slices/systemSlice';
import toastReducer from './slices/toastSlice';
import dataProcessingReducer from './slices/dataProcessingSlice';
import themeReducer from './slices/themeSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    users: userReducer,
    entities: entityReducer,
    system: systemReducer,
    toast: toastReducer,
    dataProcessing: dataProcessingReducer,
    theme: themeReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
